import '@vfde-brix/help-and-support-contact/dist/styles.css';
import '@vfde-brix/helpful/dist/styles.css';
import '@vfde-brix/feedback/dist/styles.css';
import '@vfde-brix/contact-us/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/notification/dist/styles.css';
import { createHelpAndSupportContactComponent } from '@vfde-brix/help-and-support-contact';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-HelpAndSupportContact', createHelpAndSupportContactComponent, NO_PATTERN_BUSINESS_LOGIC);
